import styled from 'styled-components/macro';
import {
  defaultContainer,
  paddingDefault,
  paddingDesktop,
  maxWidthDefault
} from '../../../styles/utils';
import { tabContainer } from '../../../components/TabStyles';

export const StatisticsDiv = styled.div`
  ${props => props.theme.bottomDropShadow}
  z-index: 1;
  position: relative;
  padding-bottom: 5rem;
  @media screen and (min-width: 768px) {
    padding-bottom: 8rem;
  }
`;

export const StatisticsHeaderDiv = styled.div`
  /* ${defaultContainer} */
  ${tabContainer}
  @media screen and (min-width: 768px) {
    padding: 5rem ${paddingDefault} 0;
  }
  /* @media screen and (min-width: 1024px) {
    padding: 5rem ${paddingDefault} 0;
  } */
  @media screen and (min-width: 1440px) {
    padding: 5rem ${paddingDesktop} 0;
    max-width: ${maxWidthDefault}px;
  }

  padding-top: 5rem;
  margin-bottom: 3rem;
  @media screen and (max-width: 767px) {
    /* margin-left: -2rem; */
  }
`;
